import { Component, OnInit, AfterViewInit } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { ApiService } from "src/app/services/api/api.service";
import { map, catchError } from "rxjs/operators";
import { BehaviorSubject, Subscription, combineLatest, of } from "rxjs";
import { Store } from "@ngrx/store";
import { IAppState } from "src/app/store/states/app";
import {
  selectManageOwnAuctions,
  selectAuthenticatedUser,
} from "src/app/store/selectors";
import { MeRequest } from "src/app/store/actions/user";

@Component({
  selector: "app-personal-information",
  templateUrl: "./personal-information.component.html",
  styleUrls: ["./personal-information.component.scss"],
})
export class PersonalInformationComponent implements OnInit, AfterViewInit {
  private messageTypes = [
    {
      display_name: "ტელეფონის ნომერი",
      id: "phone",
    },
    {
      display_name: "ელ-ფოსტა",
      id: "email",
    },
  ];
  private initialFormParams = {
    first_name: null,
    last_name: null,
    email: null,
    sms_code: null,
    old_email_code: null,
    old_sms_code: null,
    message_type: "phone",
    phone_number: null,
    country_id: null,
    phone_country_id: null,
    city_id: null,
  };

  private handleCityrequests: boolean = true;

  private selectCanUserManageAuctionSubscription: Subscription;
  private userInformation;
  private canManageAuction: boolean;
  private isOpen = new BehaviorSubject(false);
  private isDisabled: boolean = false;
  private personalInformationForm: FormGroup;

  private verifiedPhoneInfo: Array<string> = [];
  private verifiedEmailInfo: Array<string> = [];
  private countriesRequestSubscription: Subscription;
  private countries: Array<any> = [];
  private countryIdSubscription: Subscription;
  private citiesSubscription: Subscription;
  private cities: Array<any> = [];
  public savedCities: object = {};

  private currentCountryCodeSubscription: Subscription;
  private oldSmsCodeSubscription: Subscription;
  private oldEmailCodeSubscription: Subscription;
  private emailCodeSubscription: Subscription;
  private smsCodeSubscription: Subscription;
  private phoneNumberSubscription: Subscription;
  private emailSubscription: Subscription;
  public oldSmsIsChecked: boolean = false;
  public smsIsChecked: boolean = false;
  public emailIsChecked: boolean = false;
  public oldEmailChecked: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private _store: Store<IAppState>,
  ) {}

  ngOnInit() {
    this.countriesRequestSubscription = this.apiService
      .get("countries")
      .pipe(
        map((response) => response.data),
        map((countries) =>
          countries.map((country) => ({
            id: country.id,
            name: country.display_name,
            phone_code: country.phone_code,
            regex: country.phone_validation_regex,
            example: country.valid_phone_example,
          })),
        ),
      )
      .subscribe((countries) => {
        this.countries = countries;
      });

    this.personalInformationForm = this.formBuilder.group({
      first_name: new FormControl(null),
      last_name: new FormControl(null),
      email: new FormControl(null),
      sms_code: new FormControl(null),
      email_code: new FormControl(null),
      old_sms_code: new FormControl(null),
      old_email_code: new FormControl(null),
      message_type: new FormControl("phone"),
      phone_number: new FormControl(null),
      country_id: new FormControl(null),
      phone_country_id: new FormControl(null),
      city_id: new FormControl(null),
    });

    this.selectCanUserManageAuctionSubscription = combineLatest(
      this._store.select(selectManageOwnAuctions),
      this._store.select(selectAuthenticatedUser),
    ).subscribe(([canManageAuctions, userInfo]) => {
      this.canManageAuction = canManageAuctions;
      this.userInformation = userInfo.me;

      if (this.userInformation) {
        this.personalInformationForm
          .get("first_name")
          .setValue(this.userInformation.first_name);
        this.personalInformationForm
          .get("last_name")
          .setValue(this.userInformation.last_name);
        this.personalInformationForm
          .get("phone_number")
          .setValue(this.userInformation.phone_number);
        this.personalInformationForm
          .get("email")
          .setValue(this.userInformation.email);
        this.personalInformationForm
          .get("country_id")
          .setValue(this.userInformation.phone_country_id);
        this.personalInformationForm
          .get("city_id")
          .setValue(this.userInformation.city_id);

        Object.keys(this.initialFormParams).forEach((key) => {
          if (Object.keys(this.userInformation).includes(key)) {
            this.initialFormParams[key] = this.userInformation[key];
          }
        });
        this.initialFormParams["country_id"] =
          this.userInformation["phone_country_id"];

        if (this.userInformation) {
          this.personalInformationForm.setControl(
            "legal_address",
            new FormControl(null),
          );
          this.personalInformationForm.setControl(
            "legal_address",
            new FormControl(null),
          );
          this.personalInformationForm.setControl(
            "legal_form",
            new FormControl(null),
          );
          this.personalInformationForm.setControl(
            "personal_number",
            new FormControl(null),
          );
          this.personalInformationForm
            .get("legal_form")
            .setValue(this.userInformation.legal_form);
          this.personalInformationForm
            .get("legal_address")
            .setValue(this.userInformation.legal_address);
          this.personalInformationForm
            .get("personal_number")
            .setValue(this.userInformation.personal_number);

          this.initialFormParams["legal_form"] =
            this.userInformation["legal_form"];
          this.initialFormParams["legal_address"] =
            this.userInformation["legal_address"];
          this.initialFormParams["personal_number"] =
            this.userInformation["personal_number"];
        }
      }
    });
    this.handleFormChanges();

    // setTimeout(() => {
    //   this.handleFormChanges();
    // }, 0);
  }

  ngAfterViewInit() {
    this.phoneNumberSubscription = this.personalInformationForm
      .get("phone_number")
      .valueChanges.subscribe((value) => {
        this.form.get("old_sms_code").reset();
        this.form.get("sms_code").reset();
        this.form.get("message_type").enable();
      });

    this.emailSubscription = this.personalInformationForm
      .get("email")
      .valueChanges.subscribe((value) => {
        this.form.get("old_email_code").reset();
        this.form.get("email_code").reset();
        this.form.get("message_type").enable();
      });

    this.smsCodeSubscription = this.personalInformationForm
      .get("sms_code")
      .valueChanges.subscribe((value) => {
        if (
          this.personalInformationForm.get("sms_code").value &&
          this.personalInformationForm.get("sms_code").value.length === 4
        ) {
          this.smsIsChecked = true;
          this.onSubmit();
          this.oldSmsIsChecked = false;
          this.smsIsChecked = false;
        }
      });
    this.emailCodeSubscription = this.personalInformationForm
      .get("email_code")
      .valueChanges.subscribe((value) => {
        if (
          this.personalInformationForm.get("email_code").value &&
          this.personalInformationForm.get("email_code").value.length === 4
        ) {
          this.emailIsChecked = true;
          this.onSubmit();
          this.oldEmailChecked = false;
          this.emailIsChecked = false;
        }
      });
    /**
     * Subscribe to country code change and pick country data for future usage
     */

    this.currentCountryCodeSubscription = this.personalInformationForm
      .get("country_id")
      .valueChanges.pipe(
        map((id) =>
          this.countries.length
            ? this.countries.find((country) => country.id == id)
            : "",
        ),
      )
      .subscribe((country) => {
        this.personalInformationForm
          .get("phone_country_id")
          .setValue(country.id);
        // this.countryCode = country;
        /**
         *
         * Update validators for phone_number
         */
        this.personalInformationForm.get("phone_number").enable();
        //Reset validators
        this.personalInformationForm.get("phone_number").clearValidators();
        //Set Regex validator
        // this.personalInformationForm.get('phone_number').setValidators([Validators.required, regexValidator(country.regex, { pattern: country.example })]);
        this.personalInformationForm
          .get("phone_number")
          .setValidators([
            Validators.required,
            Validators.pattern(new RegExp(country.regex)),
          ]);
        //Force to revalidate form item
        this.personalInformationForm
          .get("phone_number")
          .updateValueAndValidity();
      });
  }

  handleFormChanges() {
    this.countryIdSubscription = this.form
      .get("country_id")
      .valueChanges.subscribe((id) => {
        if (
          this.handleCityrequests &&
          id &&
          !Object.keys(this.savedCities).includes(
            this.form.get("country_id").value.toString(),
          )
        ) {
          this.handleCityrequests = false;
          this.citiesSubscription = this.apiService
            .get(`cities/${id}`)
            .pipe(
              map((response) => response.data),
              map((countries) =>
                countries.map((country) => ({
                  id: country.id,
                  name: country.display_name,
                })),
              ),
            )
            .subscribe((cities) => {
              if (
                Object.values(this.savedCities).some(
                  (item) => item.id != this.form.get("city_id").value,
                )
              ) {
                this.form.get("city_id").reset("");
              }
              this.savedCities[this.form.get("country_id").value.toString()] =
                cities;
              this.handleCityrequests = true;
            });
        }
      });
  }

  onSubmit() {
    const dontSend = ["message_type"];
    const requestData = new FormData();
    Object.keys(this.form.value).forEach((key) => {
      if (this.form.get(key).value && !dontSend.includes(key)) {
        requestData.append(key, this.form.get(key).value);
      }
    });
    requestData.append("_method", "patch");
    this.apiService
      .post("profile/update", requestData)
      .pipe(
        map((response: any) => response),
        catchError((resp: any) => {
          const errorKeys = Object.entries(resp.error.errors);
          errorKeys.forEach(([key, val]) => {
            const err = {};
            err[key] = val;
            this.personalInformationForm.get(key).setErrors(err);
          });
          return "error";
        }),
      )
      .subscribe((response) => {
        if (response.result) {
          this._store.dispatch(new MeRequest({}));
          this.form.reset(this.initialFormParams);
          this.isOpen.next(false);
          this.verifiedEmailInfo = [];
          this.verifiedPhoneInfo = [];
        }
      });
  }

  verifyOldCode(type) {
    if (this.personalInformationForm.get("message_type").value === "phone") {
      this.oldSmsIsChecked = true;
      this.oldSmsCodeSubscription = this.personalInformationForm
        .get("old_sms_code")
        .valueChanges.subscribe((value) => {
          if (
            this.personalInformationForm.get("old_sms_code").value &&
            this.personalInformationForm.get("old_sms_code").value.length === 4
          ) {
            if (this.oldSmsIsChecked && type === "phone") {
              this.phoneVerificationCode();
            } else if (this.oldSmsIsChecked && type === "email") {
              this.emailVerificationCode();
            }
          }
        });
    } else if (
      this.personalInformationForm.get("message_type").value === "email"
    ) {
      this.oldEmailChecked = true;
      this.oldEmailCodeSubscription = this.personalInformationForm
        .get("old_email_code")
        .valueChanges.subscribe((value) => {
          if (
            this.personalInformationForm.get("old_email_code").value &&
            this.personalInformationForm.get("old_email_code").value.length ===
              4
          ) {
            if (this.oldEmailChecked && type === "email") {
              this.emailVerificationCode();
            } else if (this.oldEmailChecked && type === "phone") {
              this.phoneVerificationCode();
            }
          }
        });
    }
  }
  phoneVerificationCode() {
    this.form.get("message_type").disable();
    this.apiService
      .post("validate/phone", {
        phone_number: this.getUserInformation.phone_number,
        country_id: this.getUserInformation.country_id,
      })
      .pipe(map((response: any) => response))
      .subscribe((response) => {
        if (response.result) {
          this.personalInformationForm.get("sms_code").reset();
          this.verifiedPhoneInfo.push(
            `${this.personalInformationForm.get("country_id").value}-${this.personalInformationForm.get("phone_number").value}`,
          );
          this.oldSmsIsChecked = false;
          this.oldEmailChecked = false;
        }
      });
  }

  emailVerificationCode() {
    this.form.get("message_type").disable();
    this.apiService
      .post("validate/email", {
        email: this.personalInformationForm.get("email").value,
      })
      .pipe(map((response: any) => response.data))
      .subscribe(() => {
        this.personalInformationForm.get("email_code").reset();
        this.verifiedEmailInfo.push(
          `${this.personalInformationForm.get("email").value}`,
        );
        this.oldEmailChecked = false;
        this.oldSmsIsChecked = false;
      });
  }

  isComponentClosed(event: boolean): void {
    if (event) {
      this.form.reset(this.initialFormParams);
      this.verifiedEmailInfo = [];
      this.verifiedPhoneInfo = [];
    }
  }

  isComponentDisabled(event) {
    if (!event) {
      // this.form.reset({ message_type: 'phone' });
    }
    this.isDisabled = event;
  }

  get citiesList() {
    return Object.keys(this.savedCities)
      ? this.savedCities[this.form.get("country_id").value]
      : [];
  }

  get findUserCountry() {
    return this.countries.length
      ? this.countries.find(
          (item) => item.id === this.getUserInformation.country_id,
        ).name
      : "";
  }

  get findUserCity() {
    return this.citiesList &&
      this.citiesList.find(
        (item) => item.id === this.getUserInformation.city_id,
      )
      ? this.citiesList.find(
          (item) => item.id === this.getUserInformation.city_id,
        ).name
      : "";
  }

  get countriesList() {
    return this.countries;
  }

  get codeWasSentForThisNumber(): boolean {
    return (
      this.verifiedPhoneInfo.indexOf(
        `${this.personalInformationForm.get("country_id").value}-${this.personalInformationForm.get("phone_number").value}`,
      ) != -1
    );
  }

  get codeWasSentForThisEmail(): boolean {
    return (
      this.verifiedEmailInfo.indexOf(
        `${this.personalInformationForm.get("email").value}`,
      ) != -1
    );
  }

  get getMessageTypes() {
    return this.messageTypes;
  }

  get getUserInformation() {
    return this.userInformation ? this.userInformation : {};
  }

  get userCanManageAuction() {
    return this.canManageAuction;
  }

  get isComponentOpen() {
    return this.isOpen;
  }

  get getIsDisabled() {
    return this.isDisabled;
  }

  get form() {
    return this.personalInformationForm;
  }

  onDestroy() {
    if (this.selectCanUserManageAuctionSubscription) {
      this.selectCanUserManageAuctionSubscription.unsubscribe();
    }
    if (this.countriesRequestSubscription) {
      this.countriesRequestSubscription.unsubscribe();
    }
    if (this.currentCountryCodeSubscription) {
      this.currentCountryCodeSubscription.unsubscribe();
    }
    if (this.oldSmsCodeSubscription) {
      this.oldSmsCodeSubscription.unsubscribe();
    }
    if (this.oldEmailCodeSubscription) {
      this.oldEmailCodeSubscription.unsubscribe();
    }
    if (this.emailCodeSubscription) {
      this.emailCodeSubscription.unsubscribe();
    }
    if (this.smsCodeSubscription) {
      this.smsCodeSubscription.unsubscribe();
    }
    if (this.phoneNumberSubscription) {
      this.phoneNumberSubscription.unsubscribe();
    }
    if (this.emailSubscription) {
      this.emailSubscription.unsubscribe();
    }
    if (this.countryIdSubscription) {
      this.countryIdSubscription.unsubscribe();
    }
    if (this.citiesSubscription) {
      this.citiesSubscription.unsubscribe();
    }
  }
}
